import { CoreResource } from "../../core/index.js";
export class PimResource extends CoreResource {
    /**
     * Points to CIM level.
     */
    pimInterpretation = null;
    /**
     * Label used by file formats, may represent a name of a property
     * in JSON or tag name in XML.
     */
    pimTechnicalLabel = null;
    /**
     * Label used in human readable documents as a name for this resource.
     */
    pimHumanLabel = null;
    /**
     * Description, longer plain text, shown in human readable documents
     * as a description for this resource.
     */
    pimHumanDescription = null;
    constructor(iri) {
        super(iri);
    }
}
//# sourceMappingURL=pim-resource.js.map